(function ($) {
  if ($('.banner-third-level').length > 0) {
    function matchHeights() {
      $('.banner-third-level').each(function () {
        var $banner = $(this);
        var $textWrapper = $banner.find('.text-wrapper');
        var $imgWrapper = $banner.find('.img-wrapper');
        var windowWidth = $(window).width();
        
        if (windowWidth >= 992) {
          $imgWrapper.css('height', 'auto');
          var textWrapperHeight = $textWrapper.outerHeight();
          
          if (textWrapperHeight > 0) {
            $imgWrapper.css('height', textWrapperHeight - 2 + 'px');
          }
        } else {
          $imgWrapper.css('height', 'auto');
        }
      });
    }

    $(document).ready(function () {
      setTimeout(function () {
        matchHeights();
      }, 100);
    });

    var resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        matchHeights();
      }, 250);
    });

    $(window).on('load', function () {
      matchHeights();
    });
  }
})(jQuery);

